export default __webpack_public_path__ + "static/media/sketch05.8d93b176.jpg";